import { campaignStatuses } from '@dotone/react-ui-core/constants';

export const affiliateDefaultColumns = [
  'email',
  'siteInfos',
  'networkPerformance',
  'networkHistory',
];

export const affiliateTabs = {
  ALL: 'all',
  ACTIVE: 'active',
  PENDING: 'pending',
  UNAVAILABLE: 'unavailable',
  FAVORITE: 'favorite',
};

export const affiliateSourceTypes = {
  MARKETPLACE: 'marketplace',
  DIRECT_AP: 'directAp',
};

export const approvalStatusesByStatus = {
  [affiliateTabs.ACTIVE]: [campaignStatuses.ACTIVE],
  [affiliateTabs.PENDING]: [campaignStatuses.CONFIRMING, campaignStatuses.PENDING],
  [affiliateTabs.UNAVAILABLE]: [campaignStatuses.PAUSED, campaignStatuses.SUSPENDED],
};
